<template>
  <b-alert
    show
    variant="danger"
    :class="`${$attrs.class} p-1 mb-0`"
  >
    <p v-html="getMessages.summary" />

    <ul>
      <li v-if="showCheckPaymentStatus">
        {{ getMessages.checkStatus }}

        <e-button
          :id="`${$attrs.id}-pix_message-btn_check_payment`"
          style="padding: 5px"
          variant="primary"
          icon="search"
          @click="() => $emit('check-payment-status')"
        />
      </li>

      <li v-if="showConfirmPayment">
        {{ getMessages.manualConfirm }}

        <e-button
          :id="`${$attrs.id}-pix_message-btn_confirm_payment`"
          style="padding: 5px"
          variant="primary"
          icon="check2-circle"
          @click="() => $emit('confirm-payment')"
        />

        {{ getMessages.manualConfirmNote }}
      </li>

      <li v-if="showDelete">
        {{ getMessages.delete }}

        <e-button
          :id="`${$attrs.id}-pix_message-btn_delete`"
          style="padding: 5px"
          tabindex="-1"
          variant="danger"
          icon="trash"
          @click="() => $emit('delete')"
        />
      </li>
    </ul>

    <p v-html="getMessages.resume" />
  </b-alert>
</template>

<script>
import EButton from '@/views/components/EButton.vue'
import { BAlert } from 'bootstrap-vue'

export default {
  components: { BAlert, EButton },

  props: {
    isAtm: {
      type: Boolean,
      default: false,
    },
    paymentData: {
      type: Object,
      required: true,
    },
    showCheckPaymentStatus: {
      type: Boolean,
      default: false,
    },
    showConfirmPayment: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getMessages() {
      if (this.isAtm) {
        return {
          summary: this.$t('PAY_BOX_SALE.TEF.ATM.ERROR_PIX_TRANSACTION.SUMMARY'),
          checkStatus: this.$t('PAY_BOX_SALE.TEF.ATM.ERROR_PIX_TRANSACTION.CHECK_STATUS'),
          manualConfirm: this.$t('PAY_BOX_SALE.TEF.ATM.ERROR_PIX_TRANSACTION.MANUAL_CONFIRM'),
          manualConfirmNote: '',
          delete: this.$t('PAY_BOX_SALE.TEF.ATM.ERROR_PIX_TRANSACTION.DELETE'),
          resume: this.$t('PAY_BOX_SALE.TEF.ATM.ERROR_PIX_TRANSACTION.RESUME'),
        }
      }

      return {
        summary: this.$t('PAY_BOX_SALE.TEF.ERROR_PIX_TRANSACTION.SUMMARY'),
        checkStatus: this.$t('PAY_BOX_SALE.TEF.ERROR_PIX_TRANSACTION.CHECK_STATUS'),
        manualConfirm: this.$t('PAY_BOX_SALE.TEF.ERROR_PIX_TRANSACTION.MANUAL_CONFIRM'),
        manualConfirmNote: this.$t('PAY_BOX_SALE.TEF.ERROR_PIX_TRANSACTION.MANUAL_CONFIRM_NOTE'),
        delete: this.$t('PAY_BOX_SALE.TEF.ERROR_PIX_TRANSACTION.DELETE'),
        resume: this.$t('PAY_BOX_SALE.TEF.ERROR_PIX_TRANSACTION.RESUME', {
          uuid: this.paymentData.saleUuid,
        }),
      }
    },
  },

  methods: {},
}
</script>

<style lang="scss" scoped></style>
